module.exports = __webpack_public_path__ + "img/login-bg.b42e4361.png";